import AdversarialTextBox from './AdversarialTextBox'

export default AdversarialTextBox
